import {
    CREATE_SJFDASHBOARD,
    RETRIEVE_SJFDASHBOARD,
    RETRIEVESINGLE_SJFDASHBOARD,
    UPDATE_SJFDASHBOARD,
    DELETE_SJFDASHBOARD,
  } from "../actions/type";
  const initialState = [];
  function SJFDashboardReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_SJFDASHBOARD:
        return {data: state.data, payload};
      case RETRIEVE_SJFDASHBOARD:
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVESINGLE_SJFDASHBOARD:
        state = (payload.error == 1)?initialState:payload;
        return {data: state.data, payload};
      case UPDATE_SJFDASHBOARD:
        return {data: state.data, payload};
      case DELETE_SJFDASHBOARD:
        return {data: state.data, payload};
      default:
        return state;
    }
  };
  export {SJFDashboardReducer};